// extracted by mini-css-extract-plugin
export default {"follow_candidates":"social-suggested-followees-FollowBlock__follow_candidates--3zwfp"};